export default __webpack_public_path__ + "static/media/15-MD-SIR-PICNIC-SPEECH-2018.0d43be50.JPG";